export enum VerticalAlignmentEnum {
    TOP = 'top',
    MIDDLE = 'middle',
    BOTTOM = 'bottom'
};
